// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientAccountIsPatientRegisteredDefaultResponse {
    static getAttributeTypeMap() {
        return PatientAccountIsPatientRegisteredDefaultResponse.attributeTypeMap;
    }
}
PatientAccountIsPatientRegisteredDefaultResponse.discriminator = undefined;
PatientAccountIsPatientRegisteredDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IPatientRegistrationData"
    }
];
//# sourceMappingURL=patientAccountIsPatientRegisteredDefaultResponse.js.map